export default __webpack_public_path__ + "static/media/openpay.e0773e5d.png";